import http from '@/plugins/axios';
export default {
  validarEmail: function validarEmail(email) {
    var check_mx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return http.apiValidator.get("email?address=" + email + "&check_mx=" + check_mx);
  }
};